/** @prettier */

import {useEffect, useState} from 'react';

//API import
import {
  getCompositionsGateway,
  getCompositionsSLIFUnit,
  getCompositionsSLUnit,
} from '../../API/API_Collection';
//interface import
import {layoutUnitListType} from '../../Type/TypeDef';

/**
 * SL通信の室内機とインターフェースの型式リストを画面読み込み時に取得するフック
 * @param siteId サイトID
 * @returns SL通信の室内機とインターフェースの型式リスト
 */
export const useGetUnitTypeList = (siteId: string) => {
  /** SL通信の室内機とインターフェースの型式リスト */
  const [unitTypeList, setUnitTypeList] = useState<layoutUnitListType>([]);

  useEffect(() => {
    //サイトに登録されているゲートウェイのユニット登録台数を取得
    getCompositionsGateway(siteId, {
      'fields': 'register-number',
      'max-result': 100,
    }).then(response => {
      const promises = [];
      //各ゲートウェイに登録されているSL通信の室外機とインターフェースの登録情報を取得する
      for (const gwInfo of response['gateway-informations']) {
        if (
          gwInfo['register-number'] === undefined ||
          (gwInfo['register-number']['sl-system-1']['indoor-unit'] === '0' &&
            gwInfo['register-number']['sl-system-2']['indoor-unit'] === '0')
        ) {
          continue;
        }
        promises.push(
          getCompositionsSLUnit(siteId, gwInfo['gateway-id'], {
            'fields': 'indoor-unit-informations',
            'max-result': 400,
          })
        );
        promises.push(
          getCompositionsSLIFUnit(siteId, gwInfo['gateway-id'], {
            'fields': 'unit-type',
            'max-result': 400,
          })
        );
      }
      Promise.all(promises).then(response => {
        /** SL通信の室内機とインターフェースの型式リスト保存用配列 */
        const unitTypeListArray: layoutUnitListType = [];
        for (const info of response) {
          //SL通信の室外機の場合、室外機に登録されている室内機のIDと型式を取得する
          if ('outdoor-unit-informations' in info) {
            for (const slOU of info['outdoor-unit-informations']) {
              if (slOU['indoor-unit-informations'] === undefined) {
                continue;
              }
              for (let slIU of slOU['indoor-unit-informations']) {
                unitTypeListArray.push({
                  unitID: slIU['unit-id'],
                  unitType: slIU['indoor-unit-type'],
                });
              }
            }
            //インターフェースの場合、IDと型式を取得する
          } else {
            for (let slIF of info['unit-informations']) {
              if (slIF['unit-type'] === undefined) {
                continue;
              }
              unitTypeListArray.push({
                unitID: slIF['unit-id'],
                unitType: slIF['unit-type'],
              });
            }
          }
        }
        setUnitTypeList(unitTypeListArray);
      });
    });
  }, [siteId]);

  return {unitTypeList};
};
